import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'food'})
export class DvlFoodPipe implements PipeTransform {
  transform(key: string, foods: any[]): string {
    let food: any;
    let name: string = '';

    if (foods) {
      food = foods.find((food)=> food.$key === key);
      name = food ? food.name : '';
    }

    return name;
  }
}



// WEBPACK FOOTER //
// /Proyectos-Ankaa/proyecto-meriendas-diverland/src/app/pipes/food.pipe.ts